import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
    element.style.position = "fixed";
    const infodeskTop = window.innerHeight * 0.617;
    const infodeskWidth = window.innerWidth * 0.090 ;
    const infodeskHeight = infodeskWidth * 0.241;
    const infodeskLeft = window.innerWidth - infodeskWidth;

    element.style.top = infodeskTop + "px";
     element.style.left = infodeskLeft + "px";
    element.style.width = infodeskWidth + "px";
    element.style.height = infodeskHeight + "px";
    element.style.left = (window.innerWidth * 0.239) + "px";
}

const infoDesk: DirectiveOptions = {
    inserted(el, binding) {
        setPosition(el, binding);
    },
    update(el, binding) {
        setPosition(el, binding);
    }
};

export default infoDesk;
